// extracted by mini-css-extract-plugin
export default {"separator":"BreadcrumbItem_separator__doifk"};